import Image from 'next/image'
import Link from 'next/link'

import { SpecialPromotionProduct } from '@/entities/cart/api/special-promotion'

import { BASE_URL } from '@/shared/lib/const/env'
import { formatPrice } from '@/shared/lib/utils/price/format-price'
import { Button } from '@/shared/ui'

import cl from './promotion-product-card.module.scss'

type PromotionProductCardProps = {
	product: SpecialPromotionProduct
	isLoading?: boolean
	onBuy: (product: SpecialPromotionProduct) => void
}

export const PromotionProductCard = (props: PromotionProductCardProps) => {
	const { product, isLoading, onBuy } = props
	const productLink = product.KOD ? `/products/productID${product.KOD}` : undefined
	const productImage = product.IMAGE?.startsWith('http') ? product.IMAGE : `${BASE_URL}${product.IMAGE}`
	const preview = (
		<>
			<div className={cl.image}>
				<Image src={productImage} width={180} height={180} alt={product.TITLE} />
			</div>
			<p className={cl.title}>{product.TITLE}</p>
		</>
	)

	return (
		<div className={cl.root}>
			{productLink ? (
				<Link href={productLink} className={cl.link}>
					{preview}
				</Link>
			) : (
				preview
			)}
			<div className={cl.pricePanel}>
				<p className={cl.price}>{formatPrice(product.PRICE.VALUE)}</p>
				{!!product.OLD_PRICE?.VALUE && <p className={cl.oldPrice}>{formatPrice(product.OLD_PRICE.VALUE)}</p>}
			</div>
			<Button className={cl.button} isLoading={isLoading} disabled={isLoading} onClick={() => onBuy(product)}>
				Купить
			</Button>
		</div>
	)
}
